// extracted by mini-css-extract-plugin
module.exports = {"h5button":"gU","h5Button":"gU","button":"gV","block":"gW","btnDefault":"gX","disable":"gY","btnPrimary":"gZ"};